import { TablePaginationConfig } from "antd";
import { promoCodesApi } from "api/promoCode";
import { referralsApi } from "api/referral";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { IPromoCode } from "models/promoCode";
import { IReferral } from "models/referral";
import { ChangeEvent, useEffect, useState } from "react";

export default function usePromoCode() {
  const { showError } = useNotificationContext();
  const [referrals, setReferrals] =
    useState<ITableData<IReferral>>(defaultTableData);
  const [promoCodes, setPromoCodes] =
    useState<ITableData<IPromoCode>>(defaultTableData);

  useEffect(() => {
    fetchReferral();
  }, [referrals.page, referrals.search]); // eslint-disable-line

  useEffect(() => {
    fetchPromoCode();
  }, [promoCodes.page, promoCodes.search]); // eslint-disable-line

  const fetchReferral = async () => {
    setReferrals((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await referralsApi(
      referrals.page,
      referrals.per_page,
      referrals.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setReferrals((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setReferrals((prev) => ({ ...prev, loading: false }));
    }
  };

  const fetchPromoCode = async () => {
    setPromoCodes((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await promoCodesApi(
      promoCodes.page,
      promoCodes.per_page
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setPromoCodes((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setPromoCodes((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleReferralPageChange = ({ current }: TablePaginationConfig) => {
    if (current) setReferrals((prev) => ({ ...prev, page: current }));
  };

  const handlePromoCodePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setPromoCodes((prev) => ({ ...prev, page: current }));
  };
  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setReferrals((prev) => ({ ...prev, search: value ?? "" }));
  };

  return {
    promoCodes,
    referrals,
    handlePromoCodePageChange,
    handleReferralPageChange,
    handleSearch,
  };
}
